import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { plainToClass } from 'class-transformer';
import jwtDecode from 'jwt-decode';
import { NGXLogger } from 'ngx-logger';
import { Apiversion, MessageService, Notification, SharedDataService, Staff, VersionService, WebSocketClient } from 'orv-ui-base-lib';
import { Subscription, timer } from 'rxjs';

import { environment } from '../../../environments/environment';
import { VERSION } from '../../../environments/version';
import { AuthService } from '../../@core/auth/auth.service';
import { ResponsiveCommon } from '../../@core/responsive.common';
import { NavigationComponent } from '../../shared/header-navigation/navigation.component';

let wsClient: WebSocketClient<any>;

@Component({
	selector: 'app-full-layout',
	templateUrl: './full.component.html',
	styleUrls: ['./full.component.scss']
})
export class FullComponent extends ResponsiveCommon implements OnInit, OnDestroy, AfterViewInit {

	@ViewChild('navigation') navigationComp: NavigationComponent;

	version = VERSION;
	loggedUser: Staff;

	fullpage: boolean = false;

	connectionattempt = false;

	timerRenew: Subscription;

	customLayout: any;
	apiversion: Apiversion;
	env: string;
	currentdate: number;

	sidebarmargin: number;

	enviroment = environment;

	showSidebar: boolean = true;

	constructor(private logger: NGXLogger, private sharedDataService: SharedDataService,
		private versionService: VersionService,
		public router: Router,
		private activatedRoute: ActivatedRoute,
		private messageService: MessageService,
		private authService: AuthService) {
		super();
		this.sharedDataService.currentLoggedUser.subscribe(user => {
			this.loggedUser = user;
			if (user && (!wsClient || !wsClient.isOpen())) {
				const wsurl = environment.websocketUrl;
				this.logger.log('connecting to websocket ', wsurl);

				const uuid = 'BO' + this.authService.getUuid();
				this.sharedDataService.setUserUuid(uuid);
				// if (environment.production) {
				wsClient = new WebSocketClient(`${wsurl}/${user.id}/${uuid}`, true);

				wsClient.subscribe((data) => {
					if (data) {
						if (data.type === 'error' && !this.connectionattempt) {
							this.connectionattempt = true;
							this.messageService.sendError('Real time notifications might be affected.', 'An error occurred while connecting to WebSocket');
						} else {
							this.logger.log('connected', data);
							this.onWebSocketMessage(data);
						}
					}
				});
				// }
			}
		});

		// refresh token
		this.authService.renewV2().subscribe(() => {
			// schedule renew token
			this.scheduleRenew();
		});

		window.addEventListener('beforeunload', function (event) {
			if (wsClient) wsClient.close();
		});

		// routing
		this.router.events.filter(event => event instanceof NavigationEnd)
			.map(() => this.activatedRoute)
			.map(route => {
				while (route.firstChild) {
					route = route.firstChild;
				}
				return route;
			}).filter(route => route.outlet === 'primary')
			.mergeMap(route => route.data)
			.subscribe(event => {
				this.fullpage = event.fullpage;
				this.responsiveSidebar();
			});
	}

	ngOnInit() {
		this.responsiveSidebar();

		this.versionService.getApiversion().subscribe(data => {
			this.apiversion = data;
		});
		this.env = !environment.demo ? 'prod' : 'dev';
		this.currentdate = new Date().getTime();
	}

	ngAfterViewInit(): void {
		if (this.router.url === '/') {
			let link = null;

			setTimeout(() => {
				const links = document.getElementById('sidebarnav').querySelectorAll('a');
				for (let i = 0; i < links.length && !link; i++) {
					const l = links.item(i);
					if (l.hash)
						link = l;
				}
				if (link)
					this.router.navigate([link.hash.replace('#', '')]);
				else
					this.router.navigate(['/unauthorized']);
			}, 500);

		}
	}


	ngOnDestroy() {
		this.sharedDataService.removeNotification();
		this.logger.log('closing websocket');
		if (wsClient) wsClient.close();
		wsClient = undefined;
		if (this.timerRenew) this.timerRenew.unsubscribe();
	}

	setSidebarMargin(margin: number) {
		this.sidebarmargin = margin;
	}

	onWebSocketMessage(data: any) {
		const notification: any = plainToClass(Notification, data);
		this.sharedDataService.sendNotification(notification);
	}

	scheduleRenew() {
		const token = jwtDecode(this.authService.getToken());
		// 1h
		const d = new Date(token.exp * 1000);
		d.setUTCHours(d.getUTCHours() - 1);
		// d.setUTCSeconds(d.getUTCSeconds() - 50);
		this.timerRenew = timer(d).subscribe(() => {
			this.authService.renewV2().subscribe(() => {
				this.timerRenew.unsubscribe();
				this.scheduleRenew();
			});
		});
	}

	responsiveSidebar() {
		if (this.responsive) {
			this.showSidebar = false;
			this.navigationComp.showHide = false;
		}

	}
}
